var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDApp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple_g",
    "data-name": "Apple g",
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.965,
    height: 27.164,
    viewBox: "0 0 115.965 27.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(36.76 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(0.205 9.364)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Montserrat-Regular, Montserrat",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(0.132 24.164)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M6.365,25.036c-1.51,0-2.653-1.5-3.786-3.17A15.957,15.957,0,0,1,.2,15.831a10.092,10.092,0,0,1,.825-6.579A6.319,6.319,0,0,1,3.184,6.981,5.692,5.692,0,0,1,6.1,6.113h.062a6.722,6.722,0,0,1,2.467.644,4.587,4.587,0,0,0,1.519.446,4.675,4.675,0,0,0,1.468-.439,7.8,7.8,0,0,1,2.835-.727,3.811,3.811,0,0,1,.39.02,5.648,5.648,0,0,1,4.482,2.479l-.019.012A5.627,5.627,0,0,0,16.674,13.3a5.5,5.5,0,0,0,3.283,5.06l.006,0-.008.025a13.894,13.894,0,0,1-1.69,3.536C17.31,23.354,16.227,24.97,14.514,25H14.44a4.152,4.152,0,0,1-1.824-.469,4.814,4.814,0,0,0-2.149-.526,5.116,5.116,0,0,0-2.255.543,4.578,4.578,0,0,1-1.763.483ZM10.2,5.78c-.083,0-.167,0-.248-.01a5.289,5.289,0,0,1,1.3-3.874A5.443,5.443,0,0,1,14.862,0a5.61,5.61,0,0,1-1.276,4A4.576,4.576,0,0,1,10.2,5.78Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDApp2);
export default __webpack_public_path__ + "static/media/d-app2.f4173ed735e210f75fb7d4cdc47878f8.svg";
export { ForwardRef as ReactComponent };